import {
  CircleStackIcon,
  PlayCircleIcon,
  PresentationChartLineIcon,
  PuzzlePieceIcon,
  TrophyIcon,
} from '@heroicons/react/24/outline';

import { Sidebar } from '@/components/layout/Sidebar';
import { CanvasRoutes, RouterConfig, Routes } from '@/configs/routes';

const items = Routes.filter((r) => r.showInNavigation && r.path.startsWith('/bonfire/'));

const iconMap = {
  [RouterConfig[CanvasRoutes.BonfireSolutions].path]: PuzzlePieceIcon,
  [RouterConfig[CanvasRoutes.BonfireExecutions].path]: PlayCircleIcon,
  [RouterConfig[CanvasRoutes.BonfireModelData].path]: CircleStackIcon,
  [RouterConfig[CanvasRoutes.BonfireForecastExplorer].path]: PresentationChartLineIcon,
  [RouterConfig[CanvasRoutes.BonfireLeaderboard].path]: TrophyIcon,
};

export function BonfireSidebar() {
  return <Sidebar label="Bonfire" items={items} iconMap={iconMap} depth={1} />;
}
